import React, { useContext , useEffect, useRef, useState } from "react";
import styles from './Catalogue.module.css';
import generalStyles from '../generalAssets/GeneralAssets.module.css';
import buttonStyles from '../../buttons/Buttons.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { QuoteBasketContext } from "../../providers/QuoteBasketProvider";
import ProductCardV3 from "./ProductCardV3";
import { displayCommas, numberTo2sf } from "../../../functions/NumericalFunctions";
import HiQQuoteNavigation from "../../tabNavigation/HiQQuoteNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";
import { getTimeStamp } from "../../../functions/DateFunctions";

export default function QuoteSubmit(){

    const { user , backendEndpoint } = useContext(LoggedInContext);
    const { setDisable , handlePageChange } = useContext(BrandCountryContext);
    const { basketArray, setBasketArray , detailsObject , setDetailsObject } = useContext(QuoteBasketContext);

    const navigate = useNavigate();

    const [basketProducts,setBasketProducts] = useState([]);

    const [currSection,setCurrSection] = useState('Quote Basket');
    const [allDelInComplete,setAllDelInComplete] = useState(false);

    const [submittedQR,setSubmittedQR] = useState({});

    useEffect(() => {
        handlePageChange(window.location.pathname);
        getCatalogueItems();
    },[]);

    useEffect(() => {
        setAllDelInComplete(
            detailsObject.FAOname === '' || detailsObject.FAOname === null ||
            detailsObject.FAOemail === '' || detailsObject.FAOemail === null ||
            detailsObject.addressLine1 === '' || detailsObject.addressLine1 === null ||
            detailsObject.townOrCity === '' || detailsObject.townOrCity === null ||
            detailsObject.postcode === '' || detailsObject.postcode === null ||
            detailsObject.telephone === '' || detailsObject.telephone === null
        );
    },[detailsObject]);

    const getCatalogueItems = async () => {
        const headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(`${process.env.REACT_APP_STATUS === 'PRODUCTION'? process.env.REACT_APP_PRODUCTION_BACKEND : process.env.REACT_APP_BACKEND}/catalogue/idArray/8/${JSON.stringify(basketArray.map((item) => item.id))}`,{
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            console.log(recObj.catalogueItems[0]);
            setBasketProducts(recObj.catalogueItems);
        })
        .catch((err) => console.log(err));
    }

    useEffect(() => {
        console.log(basketProducts);
    },[basketProducts]);

    const handleEditDetailObject = (e,name) => {
        setDetailsObject((prev) => {
            return {
                ...prev,
                [name]: e.target.value
            }
        })
    }

    const handlecheckBox = (name) => {
        setDetailsObject((prev) => {
            return {
                ...prev,
                [name]: !prev[name]
            }
        })
    }

    const handleOnBehalfCheckBox = () => {
        setDetailsObject((prev) => {
            const newBool = !prev['onBehalf'];
            return {
                ...prev,
                onBehalf: newBool,
                FAOname: newBool? '' : prev['yourName'],
                FAOemail: newBool? '' : prev['yourEmail'],
            }
        })
    }

    const handleChangeYourName = (e) => {
        setDetailsObject((prev) => {
            const bool = prev['onBehalf'];
            return {
                ...prev,
                yourName: e.target.value,
                onBehalf: bool,
                FAOname: bool? prev['FAOname'] : e.target.value,
            }
        })
    }

    const handleChangeYourEmail = (e) => {
        setDetailsObject((prev) => {
            const bool = prev['onBehalf'];
            return {
                ...prev,
                yourEmail: e.target.value,
                onBehalf: bool,
                FAOemail: bool? prev['FAOemail'] : e.target.value,
            }
        })
    }

    const handleChangeSection = (sectionName) => {
        window.scroll(0,0);
        if(sectionName === 'Quote Basket'){
            setCurrSection('Quote Basket');
        } else if(sectionName === 'Delivery Details'){
            if(basketArray.length > 0){
                setCurrSection('Delivery Details');
            }
        } else if(sectionName === 'Overview'){
            if(detailsObject.FAOname === '' || detailsObject.FAOname === null){
                alert('"Attention of" field required');
            } else if(detailsObject.FAOemail === '' || detailsObject.FAOemail === null){
                alert('"Attention of Email" field required');
            } else if(detailsObject.addressLine1 === '' || detailsObject.addressLine1 === null){
                alert('"Address Line 1" field required');
            } else if(detailsObject.townOrCity === '' || detailsObject.townOrCity === null){
                alert('"Town / City" field required');
            } else if(detailsObject.postcode === '' || detailsObject.postcode === null){
                alert('"Postcode" field required');
            } else if(detailsObject.telephone === '' || detailsObject.telephone === null){
                alert('"Telephone" field required');
            } else {
                setCurrSection('Overview');
            }
        }
    }

    const handleSubmitQuote = (detailsObject,basketArray) => {
        const newObj = {
            ...detailsObject,
            code: generateQRCode()
        }
        fetch(backendEndpoint+'/submit/new',{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({userId: user.id,detailsObject: newObj,basketArray}),
            credentials: "include"
        })
        .then((res) => res.text())
        .then((data) => {
            const recObj = JSON.parse(data);
            setSubmittedQR(recObj.quoteRequest);
            setCurrSection('Submitted');
            setBasketArray([]);
            setDetailsObject({
                requestName: '',
                yourName: user.firstName+' '+user.lastName,
                yourEmail: user.email,
                onBehalf: false,
                FAOname: user.firstName+' '+user.lastName,
                FAOemail: user.email,
                addressLine1: '',
                addressLine2: '',
                townOrCity: '',
                county: '',
                postcode: '',
                telephone: '',
                specialItemRequests: '',
                notes: '',
            })
        })
        .catch((err) => console.log(err));
    }

    const addZeroSubTen = (value) => {
        let newValue;
        if(value < 10){
            newValue = `0${value}`;
        } else {
            newValue = `${value}`;
        }
        return newValue;
    }

    const generateQRCode = () => {
        const today = new Date();
        let date = today.getDate();
        let month = today.getMonth();
        month++;
        let year = `${today.getFullYear()}`;
        year = year.substring(2);
        let hours = today.getHours();
        let mins = today.getMinutes();
        return `QR-${addZeroSubTen(date)}${addZeroSubTen(month)}${addZeroSubTen(year)}-${addZeroSubTen(hours)}${addZeroSubTen(mins)}`;
    }

    useEffect(() => {
        console.log(submittedQR);
    },[submittedQR])

    const quoteBasket = () => {
        return (
            <>
                <h2>Quote Basket</h2>
                {/* <div className={styles.productCardContainer}> */}
                    {basketProducts.length > 0 && basketArray.length > 0? basketArray.map((basketItem,index) => <div className={styles.outerCard}><ProductCardV3 key={basketItem.id} basketItem={basketItem} productArray={basketProducts} type=""/><hr style={{display: `${basketProducts.length - 1 === index? 'block' : 'block'}`}}/></div>) : <div className={styles.noProducts}>No Products</div>}
                {/* </div> */}
                <div className={styles.productTotal}>
                    <p className={styles.subtotalCost}>Product Subtotal (Estimated)</p>
                    <p className={styles.subtotalCost}>
                        £{displayCommas(numberTo2sf(basketProducts.map((product) => {
                            const index = basketArray.findIndex((basketItem) => basketItem.id === product.id);
                            if(index > -1){
                                return {
                                    ...product,
                                    subTotal: basketArray[index].qty*product.stratelaSalesCost
                                };
                            } else {
                                return {
                                    ...product,
                                    subTotal: 0
                                };
                            }
                        }).reduce((acc,item) => acc + Number(numberTo2sf(item.subTotal)) , 0)))}
                    </p>
                </div>
                <div className={styles.textAreaCon}>
                    <label for="specialItemReq">
                        <h2>Special Item Requests</h2>
                    </label>
                    <textarea id="specialItemReq" placeholder="e.g custom signage" onChange={(e) => handleEditDetailObject(e,'specialItemRequests')}>{detailsObject.specialItemRequests}</textarea>
                </div>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.standard} onClick={() => navigate('/hiq/catalogue')}>Back to Catalogue</button>
                    <button disabled={basketArray.length === 0} className={buttonStyles.submitStyleHiQ} onClick={() => {handleChangeSection('Delivery Details')}}>Proceed to Delivery Details</button>
                </div>
            </>
        )
    }

    const deliveryDetails = () => {
        return (
            <>
                <h2>Delivery Details</h2>
                <div className={styles.inputCon}>
                    <label for="yourName">Your Name</label>
                    <input className={styles.medium} id="yourName" placeholder="e.g John Smith" onChange={(e) => handleChangeYourName(e)} value={detailsObject.yourName}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="yourEmail">Your Email</label>
                    <input className={styles.large} id="yourEmail" placeholder="e.g John Smith" onChange={(e) => handleChangeYourEmail(e)} value={detailsObject.yourEmail}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="FAOname">Quote on behalf of another customer</label>
                    <input type="checkbox" id="FAOname" placeholder="e.g John Smith" onChange={() => handleOnBehalfCheckBox()} value={detailsObject.onBehalf}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="name">FAO *</label>
                    <input className={styles.medium} id="name" placeholder="" onChange={(e) => handleEditDetailObject(e,'FAOname')} value={detailsObject.FAOname} disabled={!detailsObject.onBehalf}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="email">FAO Email *</label>
                    <input className={styles.large} id="email" placeholder="" onChange={(e) => handleEditDetailObject(e,'FAOemail')} value={detailsObject.FAOemail} disabled={!detailsObject.onBehalf}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="addressLine1">Address Line 1 *</label>
                    <input className={styles.large} id="addressLine1" name="addressLine1" placeholder="" onChange={(e) => handleEditDetailObject(e,'addressLine1')} value={detailsObject.addressLine1}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="addressLine2">Address Line 2</label>
                    <input className={styles.large} id="addressLine2" name="addressLine2" placeholder="" onChange={(e) => handleEditDetailObject(e,'addressLine2')} value={detailsObject.addressLine2}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="townOrCity">Town / City *</label>
                    <input className={styles.medium} id="townOrCity" name="townOrCity" placeholder="" onChange={(e) => handleEditDetailObject(e,'townOrCity')} value={detailsObject.townOrCity}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="county">County</label>
                    <input className={styles.medium} id="county" name="county" placeholder="" onChange={(e) => handleEditDetailObject(e,'county')} value={detailsObject.county}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="postcode">Postcode *</label>
                    <input className={styles.small} id="postcode" name="postcode" placeholder="" onChange={(e) => handleEditDetailObject(e,'postcode')} value={detailsObject.postcode}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="telephone">Telephone *</label>
                    <input className={styles.medium} id="telephone" name="telephone" placeholder="" onChange={(e) => handleEditDetailObject(e,'telephone')} value={detailsObject.telephone}/>
                </div>
                <div className={styles.inputCon}>
                    <label for="notes">Additional Notes</label>
                    <textarea id="notes" placeholder="e.g custom signage" onChange={(e) => handleEditDetailObject(e,'notes')}>{detailsObject.notes}</textarea>
                </div>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.standard} onClick={() => {handleChangeSection('Quote Basket')}}>Back to Quote Basket</button>
                    <button disabled={allDelInComplete} className={buttonStyles.submitStyleHiQ} onClick={() => {handleChangeSection('Overview')}}>Proceed to Overview & Submit</button>
                </div>
            </>
        )
    }

    const overview = () => {
        return (
            <>
                <h2>Overview & Submit</h2>
                <div className={styles.overviewContainer}>
                    <div>
                        <h3>Quote Basket</h3>
                        {/* <div className={styles.productCardContainer}> */}
                            {basketProducts.length > 0 && basketArray.length > 0? basketArray.map((basketItem,index) => <div className={styles.outerCard}><ProductCardV3 key={basketItem.id} basketItem={basketItem} productArray={basketProducts} type="small"/><hr style={{display: `${basketProducts.length - 1 === index? 'block' : 'block'}`}}/></div>) : <div className={styles.noProducts}>No Products</div>}
                        {/* </div> */}
                        <div className={styles.productTotal}>
                            <p className={styles.subtotalCost}>Product Subtotal (Estimated)</p>
                            <p className={styles.subtotalCost}>
                                £{displayCommas(numberTo2sf(basketProducts.map((product) => {
                                    const index = basketArray.findIndex((basketItem) => basketItem.id === product.id);
                                    if(index > -1){
                                        return {
                                            ...product,
                                            subTotal: basketArray[index].qty*product.stratelaSalesCost
                                        };
                                    } else {
                                        return {
                                            ...product,
                                            subTotal: 0
                                        };
                                    }
                                }).reduce((acc,item) => acc + Number(numberTo2sf(item.subTotal)) , 0)))}
                            </p>
                        </div>
                        <div className={styles.overviewTextCon}>
                            <p className={styles.inputName}>Special Item Requests</p>
                            <p className={styles.inputContent}>{detailsObject.specialItemRequests === '' || detailsObject.specialItemRequests === null? <span>None</span> : detailsObject.specialItemRequests}</p>
                        </div>
                    </div>
                    <div>
                        <h3>Delivery Details</h3>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>Your Name</p>
                            <p className={styles.inputContent}>{detailsObject.yourName}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>Your Email</p>
                            <p className={styles.inputContent}>{detailsObject.yourEmail}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>FAO</p>
                            <p className={styles.inputContent}>{detailsObject.FAOname}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>FAO Email</p>
                            <p className={styles.inputContent}>{detailsObject.FAOemail}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>Delivery Address</p>
                            <p className={styles.inputContent}>{detailsObject.addressLine1}</p>
                            <p className={styles.inputContent}>{detailsObject.addressLine2}</p>
                            <p className={styles.inputContent}>{detailsObject.townOrCity}</p>
                            <p className={styles.inputContent}>{detailsObject.county}</p>
                            <p className={styles.inputContent}>{detailsObject.postcode}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>Postcode</p>
                            <p className={styles.inputContent}>{detailsObject.postcode}</p>
                        </div>
                        <div className={styles.overviewInputCon}>
                            <p className={styles.inputName}>Telephone</p>
                            <p className={styles.inputContent}>{detailsObject.telephone}</p>
                        </div>
                        <div className={styles.overviewTextCon}>
                            <p className={styles.inputName}>Additional Notes</p>
                            <p className={styles.inputContent}>{detailsObject.notes === '' || detailsObject.notes === null? <span>None</span> : detailsObject.notes}</p>
                        </div>
                    </div>
                </div>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.standard} onClick={() => {handleChangeSection('Delivery Details')}}>Back to Delivery Details</button>
                    <button className={buttonStyles.submitStyleHiQ} onClick={() => handleSubmitQuote(detailsObject,basketArray)}>Submit Quote Request</button>
                </div>
            </>
        )
    }

    const submitted = () => {
        return (
            <>
                <h2>Quote Request Submitted</h2>
                <div>
                    Quote Request submitted successfully on {submittedQR.quoteRequest? getTimeStamp(new Date(submittedQR.quoteRequest.createdAt),true,true,true) : ''}
                </div>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.standard} onClick={() => navigate('/hiq/catalogue')}>Back to Catalogue</button>
                    <button className={buttonStyles.submitStyleHiQ} onClick={() => navigate("/hiq/submittedQuoteRequests")}>View all requests</button>
                </div>
            </>
        )
    }

    const failed = () => {
        return (
            <>
                <h2>Quote Request Submitted</h2>
                <div className={styles.submitContainer}>
                    <button className={buttonStyles.standard} onClick={() => navigate('/hiq/catalogue')}>Back to Catalogue</button>
                    {/* <button className={buttonStyles.submitStyleHiQ} onClick={() => handleSubmitQuote(detailsObject,basketArray)}>Submit Quote Request</button> */}
                </div>
            </>
        )
    }


    const pageObject = {
        'Quote Basket': quoteBasket(),
        'Delivery Details': deliveryDetails(),
        'Overview': overview(),
        'Submitted': submitted(),
        'Failed': failed(),
    }

    return(
        <div className={generalStyles.container} >
            <div className={styles.mobileCon}>
                <HiQQuoteNavigation currSection={currSection} setCurrSection={handleChangeSection}/>
                {pageObject[currSection]}
            </div>
        </div>
    )
}